import audio from '@/scripts/audio';
import gsap from 'gsap/gsap-core';
import { random } from 'lodash';
import { Loader, Point, Sprite } from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import { hitTestCenter } from '../utils';
import vars from '../vars';
import Actor from './Actor';

class Fuel extends Actor {
  constructor(parent, player) {
    super(parent);
    this.player = player;

    const r = random(1, 6, false);
    this.sprite = new Sprite();
    this.flower = new Sprite(Loader.shared.resources[`textures/FLOWER_${r}`].texture);
    this.shadow = new Sprite(Loader.shared.resources[`textures/FLOWER_${r}_SHADOW`].texture);

    this.frameHandler = () => { this.frame(); };

    this.sprite.addChild(this.shadow);
    this.sprite.addChild(this.flower);
    this.resize();
    this.parent.addChild(this.sprite);

    ticker.add(this.frameHandler);

    gsap.to(this.sprite, {
      angle: 360,
      repeat: -1,
      yoyo: true,
      duration: random(15, 25, false),
      ease: 'none',
    });
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.flower.anchor = new Point(0.5, 0.5);
    this.shadow.anchor = new Point(0.5, 0.5);
  }

  frame() {
    const { top } = this.sprite.getBounds();
    this.shadow.position.y = (top - (vars.layout.FRAME_HEIGHT / 2)) * 0.03;
    this.shadow.position.x = (this.player.sprite.position.x - (vars.layout.FRAME_WIDTH / 2)) * 0.05;

    if (hitTestCenter(this.sprite, this.player.sprite) && !this.player.jumping) {
      this.catch();
      this.destroy();
    }
  }

  catch() {
    state.fuel += 10;
    audio.play('fuel');
    gsap.to(this.sprite.scale, {
      x: 0,
      y: 0,
      ease: 'power2.in',
      duration: 0.2,
    }).then(() => {
      this.sprite.renderable = false;
    });
  }

  destroy() {
    gsap.killTweensOf(this.sprite);
    ticker.remove(this.frameHandler);
  }
}

export default Fuel;
